import { render, staticRenderFns } from "./WaterNewsTurn.vue?vue&type=template&id=34037749&scoped=true"
import script from "./WaterNewsTurn.vue?vue&type=script&lang=js"
export * from "./WaterNewsTurn.vue?vue&type=script&lang=js"
import style0 from "./WaterNewsTurn.vue?vue&type=style&index=0&id=34037749&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34037749",
  null
  
)

export default component.exports